import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'input[onlyDecimal]'
})
export class OnlyDecimalDirective {
  

  constructor() { }  
  
  @HostListener('keypress', ['$event']) onInputChange(e:any) {
    var toVerify = e.target.value + e.key;

    var verified = toVerify.match(/^\d*(\.\d{0,4})?$/g);
    if (!verified) {
      e.preventDefault();
      return false;
    }
    return true;
  }
}